export const storeLastLoggedInCustomerId = (customerId: number | string) => {
    window.localStorage.setItem('LAST_LOGGED_IN_CUSTOMER', JSON.stringify(customerId));
};

// sluzi len na logovacie ucely pri sledovani videa! nepouzivat na nic ine
export const getLastLoggedInCustomerId = (): number => {
    let stored = parseInt(window.localStorage.getItem('LAST_LOGGED_IN_CUSTOMER'), 10);
    if (isNaN(stored)) {
        return 0;
    }
    return stored;
};
